import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import { useEffect, useState } from "react";
import axios from "axios";
import { Viewer, Worker } from "@react-pdf-viewer/core";
import LoadingComponent from "./core/LoadingComponent";
import pdfjsWorker from "pdfjs-dist/build/pdf.worker.entry";
import { Grid } from "@mui/material";

export default function PDFViewer(props) {
  const defaultLayoutPluginInstance = defaultLayoutPlugin();
  const { id = null, isTxnLetter = false } = props;
  const [docurl, setDocUrl] = useState("");
  const [error, setError] = useState("");
  useEffect(() => {
    if (isTxnLetter) {
      getTxnLetter()
    }
    else {
      getClaimDocuments()
    }
  }, [id]);

  const getTxnLetter = () => {
    axios({
      url: `/txn/letter/${id}`,
      baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/i/claim`,
      method: "GET",
      headers: {
        "X-Client-Platform": "CLAIM-ENHANCEMENT",
        "Content-Type": "blob",
        "X-Auth-Token": `${localStorage.getItem("authToken")}`,
      },
      responseType: "blob",
    })
      .then((blob) => {
        const url = window.URL.createObjectURL(
          new Blob([blob.data], { type: "application/pdf" })
        );
        setDocUrl(url);
      })
      .catch((error) => {
        setError(error.message);
      });
  }

  const getClaimDocuments = () => {
    axios({
      url: `/document/list/${id}`,
      baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/su/support`,
      method: "GET",
      headers: {
        "X-Client-Platform": "CLAIM-ENHANCEMENT",
        "Content-Type": "blob",
        "X-Auth-Token": `${localStorage.getItem("authToken")}`,
      },
      responseType: "blob",
    })
      .then((blob) => {
        const url = window.URL.createObjectURL(
          new Blob([blob.data], { type: "application/pdf" })
        );
        setDocUrl(url);
      })
      .catch((error) => {
        setError(error.message);
      });
  }

  return (
    <div
      style={{
        height: "700px",
        padding: "2% 10%",
      }}
    >
      <Worker workerSrc={pdfjsWorker}>
        {docurl !== "" ? (
          <Viewer fileUrl={docurl} plugins={[defaultLayoutPluginInstance]} />
        ) : error !== "" ? (
          <Grid style={{ textAlign: "center" }}>
            <p>
              {error === "Request failed with status code 404"
                ? "No Document is present for this claim"
                : error}
            </p>
          </Grid>
        ) : (
          <LoadingComponent />
        )}
      </Worker>
    </div>
  );
}
